import { message } from 'antd';
import React, { useEffect } from 'react';
import { useTranslate } from '@tolgee/react';
import { useDebounceEffect } from 'ahooks';
import { useOnline, useSetOnline } from 'hooks/useOnline';
import { formatLoggerData, logger } from 'services/logger';

let offlineTimestamp = 0;

const NetworkInfo = React.memo(() => {
  const online = useOnline();
  const setOnline = useSetOnline();
  const { t } = useTranslate();

  useEffect(() => {
    const handleOnline = () => {
      setOnline(true);
    };
    const handleOffline = () => {
      setOnline(false);
      offlineTimestamp = Date.now();
    };
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useDebounceEffect(
    () => {
      if (online) {
        if (offlineTimestamp) {
          const onlineTimestamp = Date.now();
          logger.info(
            `[NetworkInfo] offlineReport, ${formatLoggerData({
              online: onlineTimestamp,
              offline: offlineTimestamp,
            })}`,
          );
          offlineTimestamp = 0;
        }
      } else {
        message.error(`${t('header.网络状态')}: ${t('header.离线')}`, 5);
      }
    },
    [online],
    { wait: 1000 },
  );
  return null;
});

export default NetworkInfo;
